import { data } from '../../svg/Map/data';
import { makeIcon } from '../makeIcon';

export const Map = makeIcon(data, 'map', 'Map');

export default Map;
